import { render, staticRenderFns } from "./importPage.vue?vue&type=template&id=50d52dae&"
import script from "./importPage.vue.ts?vue&type=script&lang=ts&"
export * from "./importPage.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports